module.exports = __webpack_public_path__ + "img/ico_day_night_relax.e0630113.svg";